import { FC } from 'react';

import { ProductCardLink } from './ProductCardLink';
import { CartonProduct } from '../../types';

interface Props {
    products: CartonProduct[];
}

export const RelatedProducts: FC<Props> = ({ products }) => {
    if (!products?.length) {
        return null;
    }

    return (
        <div className="mt-10">
            <h2 className="mb-4 text-lg font-medium">Схожі товари</h2>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-7">
                {products.map((relatedProduct) => (
                    <ProductCardLink
                        key={relatedProduct.id}
                        product={relatedProduct}
                        loading={false}
                        eagerLoadImage
                    />
                ))}
            </div>
        </div>
    );
};
